import { render, staticRenderFns } from "./quiz_option.vue?vue&type=template&id=75d3cb46&scoped=true&"
import script from "./quiz_option.vue?vue&type=script&lang=js&"
export * from "./quiz_option.vue?vue&type=script&lang=js&"
import style0 from "./quiz_option.vue?vue&type=style&index=0&id=75d3cb46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d3cb46",
  null
  
)

export default component.exports